import React from 'react';
import './OperatorModalStyles.css';

function OperatorCreatedModal({ isOpen, onClose, operatorEmail }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={(e) => {
            if (e.target === e.currentTarget) onClose();
        }}>
            <div className="modal-content operator-created-modal">
                <div className="modal-header">
                    <h2>¡Operador creado con éxito!</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>

                <div className="modal-body">
                    <div className="success-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                            <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                    </div>

                    <p className="success-message-large">
                        Usuario creado con éxito. Avisale a tu colaborador/a que acaba de recibir un email con el link de acceso en la cuenta:
                    </p>

                    <div className="operator-email">
                        {operatorEmail}
                    </div>

                    <p className="success-note">
                        El operador podrá acceder al sistema una vez que haga clic en el enlace enviado a su correo. Y podrá comenzar a verificar las transferencias recibidas.
                    </p>
                </div>

                <div className="modal-footer">
                    <button
                        className="submit-button"
                        onClick={onClose}
                        style={{ width: '100%' }}
                    >
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OperatorCreatedModal; 